import { render, staticRenderFns } from "./Index.html?vue&type=template&id=10bdf7ce&scoped=true&external"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bdf7ce",
  null
  
)

export default component.exports